import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { FC, PropsWithChildren, useMemo } from 'react';
import { useSession, signIn } from 'next-auth/react';
import { ApolloProvider } from '@apollo/client';
import MainLayout from '@layouts/main';

export const createApolloClient = (token: string) => {
  return new ApolloClient({
    link: new HttpLink({
      uri: `${process.env.NEXT_PUBLIC_API_BASE}/graphql`,
      credentials: 'same-origin',
      headers: {
        authorization: `Bearer ${token}`,
      },
    }),
    cache: new InMemoryCache({
      typePolicies: {},
    }),
  });
};

export const ApolloProviderWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { data: session, status } = useSession();

  const apolloClient = useMemo(
    () =>
      session?.accessToken ? createApolloClient(session?.accessToken) : null,
    [session?.accessToken]
  );

  if (status === 'unauthenticated') {
    void signIn('da');
  }
  if (status !== 'authenticated' || apolloClient == null) {
    return (
      <MainLayout
        alignment="top"
        panelled={false}
        restrictWidth={true}
        showSpinner
        noAuth
      />
    );
  }
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
